import readingPaneStore from '../store/Store';
import { action, select } from 'satcheljs/lib/legacy';
export var ExpandItemPartOnIsReadChangedName = 'expandItemPartOnIsReadChanged';
export default select({
    loadedConversationState: function () { return readingPaneStore.conversationReadingPaneViewState; },
})(action(ExpandItemPartOnIsReadChangedName)(function expandItemPartOnIsReadChanged(changedConversationId, nodeIds, state) {
    var loadedConversationId = state.loadedConversationState
        ? state.loadedConversationState.conversationId
        : null;
    // Only update reading pane store if conversation is currently loaded.
    if (loadedConversationId && loadedConversationId.Id == changedConversationId) {
        nodeIds.forEach(function (nodeId) {
            var itemPartViewState = state.loadedConversationState.itemPartsMap.get(nodeId);
            if (itemPartViewState && itemPartViewState.isLocal) {
                itemPartViewState.isExpanded = true;
            }
        });
    }
}));
//# sourceMappingURL=expandItemPartOnIsReadChanged.js.map